<template>
  
  <div class="group" :ref="refs['sectionsOverviewGroup']" :data-id="dataId" style="margin-bottom: 40px;">
  
    <div class="features" :class="{ 's_open' : isOpen }" v-if="builder.currentItem.data.sections.length > 1">
      <div class="features-head" @click="isOpen = !isOpen; isTouched = true;">
        <div class="features-title">My Kitchen Design</div>
        <div class="features-icon" v-if="!isAlwaysOpen">
          <svg class="icon"><use href="#chevron-down"></use></svg>
        </div>
      </div>
      <div class="features-body">
        <div class="features-body-inner l_double">
          <p>Manufactured to fit your space.</p>
        </div>
        <div class="features-body-inner l_flex">
        
          <template v-for="(section, index) in builder.currentItem.specs.sections"
            v-bind:key="`${index}`">
            <button
              type="button"
              :id="`kitchenSection${index}`"
              class="opt  l_interiors l_trio l_frameless l_config l_overview"
              :class="{ 's_active' : builder.section == (index+1) }"
              @click="selectSection(index+1)"
              role="radio"
              :aria-checked="builder.section == (index+1)">
              <div class="opt-inner">
                <div class="opt-tag">
                  <svg class="icon" v-if="builder.selectedSections[index] && builder.selectedSections[index].id"><use href="#check"></use></svg>
                  <span v-html="builder.sectionTitles[index]"></span>
                </div>
                <div class="opt-image">
                  <div class="opt-img" :style="`background-image: url(${builder.selectedSections[index].image});`" v-if="builder.selectedSections[index] && builder.selectedSections[index].id"></div>
                  <div class="opt-img" v-else></div>
                </div>
                <div class="opt-footer">
                  <div v-if="builder.selectedSections[index]">
                    <strong>{{ builder.selectedSections[index].title }}</strong>
                    <br />Width: {{ section.width }}mm
                  </div>
                  <div v-else>To be selected<br />&nbsp;</div>
                </div>
              </div>
            </button>
          </template>
        
        </div>
      </div>
    </div>
  
  </div>
  
</template>

<script setup>
  
import { ref, watch, computed } from 'vue'

const props = defineProps([
  'alwaysOpen'
])

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

import { useLightboxStore } from "@/stores/lightbox";
const lightbox = useLightboxStore();

const emit = defineEmits(['selectOption'])

const isOpen = ref(true);
const isTouched = ref(false);
const isAlwaysOpen = ref(false);
const dataId = ref('sectionsOverviewGroup');

if (!_.isUndefined(props.alwaysOpen) && props.alwaysOpen) isAlwaysOpen.value = true;

document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth < 768) {
    isOpen.value = false;
  }
});

if (builder.section == 1 && !builder.currentSection.configId) {
  isOpen.value = false;
}

if (isAlwaysOpen.value) {
  isOpen.value = true;
  dataId.value = 'sectionsOverviewSummaryGroup';
}

// watch changes to the step and update the url
watch(() => builder.section, (newValue, oldValue) => {
  if (!isTouched.value && builder.section > 1) {
    isOpen.value = true;
  }
});

function selectSection(num) {
  builder.saveCurrentItem();
  // emit('selectSection', num);
  builder.setSection(num);
}

function viewInfo(e, optIndex) {
  let infoHtml = builder.currentSectionConfigDescription;
  lightbox.open(infoHtml);
  e.preventDefault();
  return false;
}


function lightboxActivate(dataSpec, handle) {
      
  let gallery = '';
  let description = '';
  let imageClass = '';
  if (handle == 'interior') imageClass = 'interior-image';
  
  if (['panel1', 'panel2', 'panel3', 'panel4'].indexOf(handle) !== -1) {
          
      let i = parseFloat(handle.replace(/^\D+/g, ''));
      
      if (!_.isUndefined(dataSpec.group) && _.isObject(dataSpec.group)) description += '<strong>' + dataSpec.group.title + ' ' + i + ':</strong> ';
      description += dataSpec.title;
      gallery = [];
      if (dataSpec.gallery.length) gallery = generateGallery(dataSpec.gallery);
      gallery.push({ 
        id: gallery.length + 1,
        content: '<img src="' + dataSpec.image + '" alt="" class="' + imageClass + '">'
      });
     
  } else {
    
    if (!_.isUndefined(dataSpec.group) && _.isObject(dataSpec.group)) description += '<strong>' + dataSpec.group.title + ':</strong> ';
    description += dataSpec.title;
    gallery = [];
    if (dataSpec.gallery.length) gallery = generateGallery(dataSpec.gallery);
    gallery.push({ 
      id: gallery.length + 1,
      content: '<img src="' + dataSpec.image + '" alt="" class="' + imageClass + '">'
    });
    

  }
  
  if (description.length) description = '<p style="text-align: center;">' + description + '</p>';
  
  lightbox.open(description, gallery);
  
  return false;
  
}

// init refs
let refHandles = [
  'sectionsOverviewGroup',
];
const refs = _.chain(refHandles).keyBy().mapValues(ref).value();
refHandles.forEach(item => {
  builder.refs[item] = refs[item];
});
</script>